<template>
  <div id="course_list">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <!-- 头部焦点图 -->
    <div class="bannerBox w1200">
      <banner v-bind:pageTypeId="pageTypeId"></banner>
    </div>
    <!-- banner end -->
    <div class="main">
      <div class="title w1200">
        <em></em>精选课程
        <span>
          <router-link :to="{ path: '/course_list', query: { nav: 8 } }">查看更多</router-link>
        </span>
      </div>
      <div class="main_list w1200">
        <ul class="clearfix">
          <li v-for="(item, index) in listBox" :key="index">
            <router-link :to="{path:'/course_details',query:{Id:item.Id,nav:8}}">
              <dl>
                <dt><img :src="item.CoverImg"><i
                    :class="[item.Type == 2?'courseBox':'']">{{item.Type == 2?'课程包':''}}</i></dt>
                <dd class="dd1">
                  <h2>{{item.Title}}</h2>
                  <p class="p1">
                    <span v-if="item.ClassTypeName">{{item.ClassTypeName}}</span>
                    <span v-if="item.CourseTypeName">{{item.CourseTypeName}}</span>
                  </p>
                  <div class="p3">
                    ￥{{item.Price}}
                  </div>
                </dd>
                <!-- <dd class="dd2">
                  <h2>{{item.Title}}</h2>
                  <p class="p2">
                    {{item.ServiceType}}
                  </p>
                  <p class="p1">
                    <span v-if="item.ClassTypeName">{{item.ClassTypeName}}</span>
                    <span v-if="item.CourseTypeName">{{item.CourseTypeName}}</span>
                  </p>
                  <p class="p4">
                    立即学习
                  </p>
                </dd> -->
              </dl>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- main_list end -->
    </div>
    <!-- main end -->
  </div>
</template>

<script>
  import Header from "../../components/header/Header.vue"; //公共头部
  import banner from "../../page2/banner/banner.vue"; //头部banner图
  export default {
    name: "course_list",
    components: {
      // 将组件隐射为标签,登录弹窗
      Header,
      banner
    },
    metaInfo() {
      return {
        title: "热门课程 - 启德考培旗下在线课堂_出国考试在线培训_考培网校",
        meta: [{
            name: "keywords",
            content: "启德考培在线课程,雅思在线课程,托福在线课程,雅思课程,托福课程"
          },
          {
            name: "description",
            content: "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
          }
        ]
      };
    },
    data() {
      return {
        tokenkey: "",
        pageTypeId: 20, //教师banner图
        listBox: [], //列表盒子
      };
    },
    methods: {
      getDataListFu() {
        // console.log("keyword", keyword)
        let that = this;
        this.$api.get(
          "https://schoolapi.eiceducation.com.cn/api/Course?page=1&limit=8&orderType=0", "",
          res => {
            if (res.data.code == 200) {
              console.log(res,"课程列表")
              that.listBox = res.data.results;
              that.total = res.data.count;
            }
          }
        );
      },
    },
    mounted: function() {
      //自动触发写入的函数
      let that = this;
      that.tokenkey = that.$cookies.get("token");
      // console.log('searchValue2', this.searchValue)
      // 列表初始化
      that.getDataListFu();
    }
  };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* 课程包 */
  .courseBox {
    position: absolute;
    top: 10px;
    right: 0;
    width: 72px;
    height: 30px;
    line-height: 30px;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    background: rgba(0, 0, 0, 0.3);
    font-size: 14px;
    color: #fff;
    text-align: center;
  }

  .bottombox {
    position: relative;
    z-index: 9;
  }

  .header_left {
    background: #f00;
  }

  .bannerBox {
    height: 420px;
    position: relative;
    overflow: hidden;
    padding-top: 20px;
    margin-bottom: 50px;
  }

  .main {
    width: 100%;
    background: #FFFFFF;
    padding-bottom: 60px;
  }

  .main .title {
    position: relative;
    font-weight: 500;
    font-size: 24px;
    color: #333333;
    line-height: 26px;
    margin-bottom: 30px;
    position: relative;
  }
  .main .title em{
    display: block;
    float: left;
    width: 5px;
    height: 26px;
    background: #FF0659;
    border-radius: 0px 0px 0px 0px;
    margin-right: 20px;
  }

  .main .title span {
    width: 123px;
    height: 25px;
    position: absolute;
    top: 13px;
    right: 0;
    background: url(../../assets/index/more.png) no-repeat;
    background-size: cover;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 16px;
    text-align: center;
  }

  .main .title span a {
    color: #333333;
    padding-right: 5px;
  }

  .main_list li {
    width: 285px;
    height: 295px;
    float: left;
    background: #FBFBFB;
    position: relative;
    margin-right: 20px;
    margin-bottom: 20px;
    overflow: hidden;
  }

  .main_list li:nth-child(4n) {
    margin-right: 0;
  }

  .main_list li a {
    display: block;
    width: 285px;
    height: 322px;
    overflow: hidden;
  }

  .main_list li dt {
    width: 285px;
    height: 185px;
    overflow: hidden;
  }

  .main_list li dt img {
    width: 285px;
    height: 185px;
    display: block;
  }

  .main_list li .dd1 {
    width: 265px;
    padding: 10px 10px 0;
    text-align: left;
    background: url(../../assets/index/to1.png) 261px 10px no-repeat;
    background-size: 14px 14px;
  }

  .main_list li .dd1 h2 {
    height: 20px;
    font-size: 20px;
    color: #000000;
    line-height: 20px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 10px;
  }

  .main_list li .dd1 .p1 {
    width: 100%;
    height: 22px;
    margin-bottom: 10px;
    overflow: hidden;
  }

  .main_list li .dd1 .p1 span {
    display: inline-block;
    padding: 0 10px;
    height: 22px;
    background: rgba(135, 141, 255, 0.05);
    border-radius: 13px 13px 13px 13px;
    line-height: 22px;
    text-align: center;
    font-size: 12px;
    color: #878DFF;
    margin-right: 5px;
  }

  .main_list li .dd1 .p3 {
    height: 26px;
    font-weight: 400;
    font-size: 26px;
    color: #FF0659;
    line-height: 26px;
    text-align: right;
  }

  .main_list li .dd2 {
    width: 265px;
    max-height: 200px;
    padding: 18px 10px 0;
    text-align: left;
    position: absolute;
    bottom: -300px;
    left: 0;
    background: #FBFBFB;
    transition: 0.5s ease all;
  }

  .main_list li:hover .dd2 {
    bottom: 0;
  }

  .main_list li .dd2 .p2 {
    font-weight: 350;
    font-size: 12px;
    color: #666666;
    line-height: 18px;
    margin-bottom: 8px;
  }

  .main_list li .dd2 .p1 {
    width: 100%;
    height: 22px;
    margin-bottom: 2px;
    overflow: hidden;
  }

  .main_list li .dd2 .p1 span {
    display: inline-block;
    padding: 0 10px;
    height: 22px;
    background: rgba(135, 141, 255, 0.05);
    border-radius: 13px 13px 13px 13px;
    line-height: 22px;
    background: rgba(135, 141, 255, 0.05);
    text-align: center;
    font-size: 12px;
    color: #878DFF;
    margin-right: 5px;
  }

  .main_list li .dd2 .p4 {
    font-weight: 400;
    font-size: 12px;
    color: #337CFF;
    line-height: 12px;
    text-align: right;
    padding-right: 24px;
    margin-bottom: 20px;
    background: url(../../assets/index/to2.png) right no-repeat;
    background-size: 14px 14px;
  }


  .main_list li .dd2 h2 {
    height: 20px;
    font-size: 20px;
    color: #000000;
    line-height: 20px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/page2/courseList/course.vue